import {AxiosInstance, AxiosResponse} from 'axios';
//api
import {userAPI} from '@/core/api';
//types
import {INotificationFilters, INotificationResData, INotificationUpdateReqData} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';

class NotificationService {
	static getAllNotifications = async (
		data: INotificationFilters,
		apiInstance: AxiosInstance
	): Promise<AxiosResponse<INotificationResData>> => apiInstance.post(API_URL.NOTIFICATION, data);

	static updateAllNotificationsOrganizationStatus = async (
		data: INotificationUpdateReqData,
		apiInstance: AxiosInstance
	): Promise<AxiosResponse<void>> => apiInstance.put(`${API_URL.NOTIFICATION_UPDATES}`, data);

	static updateAllNotificationsUserStatus = async (userId: number): Promise<AxiosResponse<void>> =>
		userAPI.put(`${API_URL.NOTIFICATION_UPDATES}/${userId}`);

	static updateOneNotificationStatus = async (id: number, apiInstance: AxiosInstance): Promise<AxiosResponse<void>> =>
		apiInstance.put(`${API_URL.NOTIFICATION_ONE_UPDATES}/${id}`);
}

export {NotificationService};
